import { Injectable } from "@angular/core";
import { QQQuestionnaireViewModel } from "../models/qq-questionnaire.view-model";

@Injectable({
    providedIn: 'root'
})
export class CalculationService {

    public calculate(expression: string, questionnaire: QQQuestionnaireViewModel, additional: any = null) {
        const func = new Function('context', `with(context) { return ${expression}; }`);

        const context = {
            ...questionnaire.answersObject,
            ...additional,
            getAge: this.getAge,
            minPolicyTerm: this.minPolicyTerm,
            maxPolicyTerm: this.maxPolicyTerm
        };

        return func(context);
    }

    public maxPolicyTerm(dual: boolean, dob1: string, dob2: string, inclCi: boolean) {
        if (!dob1) {
            return inclCi ? 70 : 90;
        }

        let age = this.getAge(dob1);
        if (dual)
            age = Math.max(age, this.getAge(dob2));

        var ret = Math.max((inclCi ? 70 : 90) - age - 1, 1);

        return Math.min(ret, 50);
    }

    public minPolicyTerm(dual: boolean, dob1: string, dob2: string, inclCi: boolean) {
        let maxTerm = this.maxPolicyTerm(dual, dob1, dob2, inclCi);
        return Math.min(5, maxTerm);
    }

    public getAge(dob: string) {
        const date = new Date(dob);
        const ageDifMs = Date.now() - date.getTime();
        const ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

}